import request from '../../../helpers/request';

const untieTenantFromRoom = async (data) => {
  await request.put(
    `/RentPlace/rental_house/office/tenant_end`,
    data,
    'При завершении договора произошла ошибка',
    {},
    'Не удалось завершить договор'
  );
};

export default untieTenantFromRoom;
